import React, { Component } from 'react'
import DigitalSidebar from './DigitalSidebar'
import Banner from '../../components/common/Banner';
import Header from '../../components/common/Header';
import Footer from '../../components/common/Footer';

export default class VideoSurveillance extends Component {
  render() {
    return (
      <div>
        {/* Header */}
        <Header />

        {/* Banner */}
        <Banner title="Digital Library" image="banner/library-3.jpg" />

        {/* Content */}
        <div className="sidebar ttm-sidebar ttm-bgcolor-white clearfix">
          <div className="container-xl">
            <div className="row">
              <div className="col-lg-9 content-area order-lg-2">
                <div className="ttm-service-single-content-area">
                  <div className="section-title with-desc text-left clearfix">
                    <div className="title-header" style={{ borderTopColor: "red" }}>
                      <h4 className="title">CCTV Surveillance</h4>
                    </div>
                  </div>
                  <div className="ttm-service-description">
                    <p>The Library has IP based 22 CCTV Dome cameras are installed in all the sections. Video surveillance and security cameras are great security tools for Libraries, as they can protect large areas of space and allow librarians and Staff Members to immediately check in on concerns from the reference desk or office.</p><br/>
                    <ul className="ttm-list ttm-list-style-icon">
                      <li><i className="fa fa-check-circle ttm-textcolor-skincolor" /><span className="ttm-list-li-content">Security</span></li>
                      <li><i className="fa fa-check-circle ttm-textcolor-skincolor" /><span className="ttm-list-li-content">Prevent theft Flexibility</span></li>
                      <li><i className="fa fa-check-circle ttm-textcolor-skincolor" /><span className="ttm-list-li-content">Remote Monitoring</span></li>
                    </ul>
                  </div>
                  <div className="ttm-service-description paddingtop-2">
                    <h6>Electronic Surveillances</h6><br/>
                    <ul className="ttm-list ttm-list-style-icon">
                      <li><i className="fa fa-check-circle ttm-textcolor-skincolor" /><span className="ttm-list-li-content">22 CCTV cameras are installed in the library premises as security measure.</span></li>
                    </ul>
                  </div>
                </div>
              </div>
              <div className="col-lg-3 widget-area">
                <DigitalSidebar />
              </div>
            </div>
          </div>
        </div>

        {/* Footer */}
        <Footer />
      </div>
    )
  }
}
